/**
 * Detect SignalR hub errors caused by intentional disconnect / connection.stop().
 * These are expected when switching accounts and must not surface as unhandled errors.
 */

export function isHubConnectionClosedError(error: unknown): boolean {
  const message =
    error instanceof Error ? error.message : typeof error === "string" ? error : "";

  if (!message) return false;

  return (
    /Invocation canceled due to the underlying connection being closed/i.test(
      message
    ) ||
    /Connection closed/i.test(message) ||
    /Cannot send data if the connection is not in the 'Connected' State/i.test(
      message
    )
  );
}

export class HubConnectionClosedError extends Error {
  constructor(cause?: unknown) {
    super("Hub connection closed");
    this.name = "HubConnectionClosedError";
    if (cause instanceof Error) {
      this.cause = cause;
    }
  }
}
